<div class="row">
    <div class="col-md-7">
        <h2>Customers</h2>
    </div>
</div>
<div>
    <mt-search-bar (searched)="search($event)"></mt-search-bar>
    <br />
</div>

<mt-entity-list
    [entities]="customers"
    [total]="total"
    [(currentPage)]="currentPage"
    (pageChanged)="getCustomers()"
    (itemSelectedEvent)="customerSelected($event)"
    (columnSortedEvent)="columnSorted($event)"
    [entityListConfig]="entityListConfig"
    (itemDeletedEvent)="onItemDeleted($event)"
>
</mt-entity-list>

<div *ngIf="canAddCustomer" class="fab-wrap-b-r">
    <a class="btn btn-primary btn-fab-lg" [routerLink]="['/customers', 'add']">
        <span class="fa fa-plus"></span>
    </a>
</div>
